module.exports = __webpack_public_path__ + "img/cashout.cfafc841.svg";